import React from 'react';

import WelcomeContent from '../WelcomeContent';

interface WelcomeProps {
  isProSubscriber: boolean;
  handleNext: () => void;
  handleClose: () => void;
}

const Welcome = ({ isProSubscriber, handleNext, handleClose }: WelcomeProps) => (
  <div
    id="welcome-tooltip"
    className="flex min-h-[calc(100vh-252px)] w-[360px] max-w-[calc(100vw-32px)] flex-col items-center justify-center bg-grayscale-charcoal px-20 py-48"
  >
    <WelcomeContent
      variant="mobile"
      isProSubscriber={isProSubscriber}
      handleNext={handleNext}
      handleClose={handleClose}
    />
  </div>
);

export default Welcome;
